import React, { useState } from 'react'
import { TargetTitle } from 'src/components/Global/Text/TitleText'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { ModalButton } from 'src/components/Global/Button/Button'
import { useTypedSelector } from 'src/redux/root-reducer'
import { Link, useLocation } from 'react-router-dom'
import { FormContainer, CreateCollaboWrapper } from './styles'
import { CollaboTypes } from 'src/redux/types/collaboTypes'
import { action } from 'typesafe-actions'
import { useDispatch } from 'react-redux'

const AddCollaborator = () => {
  let SEARCH_DATA: any = []
  let location = useLocation()
  const [clicked, setClicked] = useState(false)
  const [collaboData, setCollaboData] = useState({
    param: '',
  })
  const { param } = collaboData
  const dispatch = useDispatch()
  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...collaboData }
    newData[name] = value
    setCollaboData(newData)
    setClicked(true)
  }

  const [isSearching, setIsSearching] = useState(false)
  const [invitees, setInvitees] = useState<Array<any>>([])
  const onSearchMember = () => {
    setIsSearching(true)
    dispatch(
      action(CollaboTypes.SEARCH_INVITEE_CALL, { param }, onSearchSuccess)
    )
  }

  const onSearchSuccess = (newInvitee: any) => {
    setIsSearching(false)
    let update = true
    setInvitees((prevState) => {
      prevState.forEach((invitee) => {
        if (invitee.id === newInvitee.id) {
          update = false
          return
        }
      })

      if (!update) {
        return [...prevState]
      }

      return [...prevState, newInvitee]
    })
    console.log(newInvitee, 'egonu')
  }
  return (
    <FormContainer>
      <CreateCollaboWrapper>
        <div className="top-content">
          <TargetTitle className="targetTitle">Invite</TargetTitle>
          <h4 className="line-height">
            Invite with email address, phone number or F & K user handle
          </h4>
          <div className="search-bar">
            <QuicksaveInput
              type="text"
              placeholder="Member's ID or email or phone No"
              name="param"
              value={param}
              onChange={handleChange}
              onBlur={onSearchMember}
            />
            {clicked && (
              <div className="search" onClick={(e: any) => onSearchMember()}>
                <p>Search</p>
              </div>
            )}
          </div>
        </div>
        <div className="added-participant">
          <p>Added Participants:0</p>
        </div>
        <div className="search-results">
          <p>Search result(s):</p>
          {SEARCH_DATA.map((item: any) => (
            <div className="added-user" key={item.id}>
              <div>
                <img src={item.profile_picture} alt="" className="user-img" />
                <h3 className="user-name">{item.name}</h3>
              </div>
              <p className="search">Add memeber</p>
            </div>
          ))}
        </div>
        <div className="top">
          <Link
            to={`/add-collaborator`}
            state={{ backgroundLocation: location }}
          >
            <ModalButton className="targets">Create Collabo</ModalButton>
          </Link>
        </div>
      </CreateCollaboWrapper>
    </FormContainer>
  )
}
export { AddCollaborator }
